import React from 'react';
import Icon from '../Icon';
import Container from './atoms/container';
const Badge = ({ type, muted, size, icon, children }) => (React.createElement(Container, { "$type": type, "$size": size, "$icon": Boolean(icon), "$muted": muted },
    icon && (React.createElement(Icon, { icon: icon, "$size": size === 'small' ? '12px' : '18px', "$color": 'neutralFill', "$marginRight": 'extraSmall' })),
    children && React.createElement("span", null, children)));
export default Badge;
